import { render, staticRenderFns } from "./Detail4.vue?vue&type=template&id=63c525f8&scoped=true&"
import script from "./Detail4.vue?vue&type=script&lang=js&"
export * from "./Detail4.vue?vue&type=script&lang=js&"
import style0 from "./Detail4.vue?vue&type=style&index=0&id=63c525f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c525f8",
  null
  
)

export default component.exports